module.exports = __webpack_public_path__ + "img/2-工具和沙盒.b272b766.gif";